// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.spf-process-editor {
  background: #ffffff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  resize: vertical;
  overflow: auto;
  min-height: 200px;
  /* Custom table toolbar button */
}
.spf-process-editor .ql-toolbar.ql-snow {
  flex: 0 0 auto;
  width: 100%;
  border: 0;
  border-bottom: 1px solid #d9d9d9;
  box-sizing: border-box;
}
.spf-process-editor .ql-toolbar.ql-snow + .ql-container.ql-snow,
.spf-process-editor .ql-container.ql-snow {
  flex: 1 1 auto;
  width: 100%;
  height: auto !important;
  min-height: 0;
  border: 0;
  box-sizing: border-box;
}
.spf-process-editor .ql-editor {
  width: 100%;
  height: 100%;
  min-height: 0;
  padding-bottom: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  resize: none;
}
.spf-process-editor .ql-editor img {
  max-width: 100%;
  height: auto;
  border-radius: 6px;
  margin: 8px 0;
}
.spf-process-editor .ql-editor .ql-table-embed {
  margin: 12px 0;
  overflow-x: auto;
  cursor: pointer;
}
.spf-process-editor .ql-editor .ql-table-embed table {
  width: 100%;
  border-collapse: collapse;
}
.spf-process-editor .ql-editor .ql-table-embed th,
.spf-process-editor .ql-editor .ql-table-embed td {
  border: 1px solid #cbd5e1;
  padding: 8px;
  vertical-align: top;
}
.spf-process-editor .ql-editor .ql-table-embed th {
  background: #f1f5f9;
  font-weight: 600;
}
.spf-process-editor .ql-snow .ql-toolbar button.ql-table,
.spf-process-editor .ql-snow.ql-toolbar button.ql-table {
  width: 28px;
}
.spf-process-editor .ql-snow .ql-toolbar button.ql-table::before,
.spf-process-editor .ql-snow.ql-toolbar button.ql-table::before {
  content: "▦";
  display: inline-block;
  font-size: 14px;
  line-height: 1;
  color: #444;
}`, "",{"version":3,"sources":["webpack://./src/pages/ContentManagement/style.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EA4DA,gCAAA;AAzDF;AADE;EACE,cAAA;EACA,WAAA;EACA,SAAA;EACA,gCAAA;EACA,sBAAA;AAGJ;AAAE;;EAEE,cAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,SAAA;EACA,sBAAA;AAEJ;AACE;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AACJ;AACI;EACE,eAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AACN;AAEI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AAAN;AAEM;EACE,WAAA;EACA,yBAAA;AAAR;AAGM;;EAEE,yBAAA;EACA,YAAA;EACA,mBAAA;AADR;AAIM;EACE,mBAAA;EACA,gBAAA;AAFR;AAQE;;EAEE,WAAA;AANJ;AASE;;EAEE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;AAPJ","sourcesContent":[".spf-process-editor {\n  background: #ffffff;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  resize: vertical;\n  overflow: auto;\n  min-height: 200px;\n\n  .ql-toolbar.ql-snow {\n    flex: 0 0 auto;\n    width: 100%;\n    border: 0;\n    border-bottom: 1px solid #d9d9d9;\n    box-sizing: border-box;\n  }\n\n  .ql-toolbar.ql-snow + .ql-container.ql-snow,\n  .ql-container.ql-snow {\n    flex: 1 1 auto;\n    width: 100%;\n    height: auto !important;\n    min-height: 0;\n    border: 0;\n    box-sizing: border-box;\n  }\n\n  .ql-editor {\n    width: 100%;\n    height: 100%;\n    min-height: 0;\n    padding-bottom: 20px;\n    box-sizing: border-box;\n    overflow-y: auto;\n    resize: none;\n\n    img {\n      max-width: 100%;\n      height: auto;\n      border-radius: 6px;\n      margin: 8px 0;\n    }\n\n    .ql-table-embed {\n      margin: 12px 0;\n      overflow-x: auto;\n      cursor: pointer;\n\n      table {\n        width: 100%;\n        border-collapse: collapse;\n      }\n\n      th,\n      td {\n        border: 1px solid #cbd5e1;\n        padding: 8px;\n        vertical-align: top;\n      }\n\n      th {\n        background: #f1f5f9;\n        font-weight: 600;\n      }\n    }\n  }\n\n  /* Custom table toolbar button */\n  .ql-snow .ql-toolbar button.ql-table,\n  .ql-snow.ql-toolbar button.ql-table {\n    width: 28px;\n  }\n\n  .ql-snow .ql-toolbar button.ql-table::before,\n  .ql-snow.ql-toolbar button.ql-table::before {\n    content: '▦';\n    display: inline-block;\n    font-size: 14px;\n    line-height: 1;\n    color: #444;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
